import * as React from 'react';
//import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ChartByStatus from './ChartByStatus';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useSelector } from 'react-redux';

function SummaryCard({ title, type }) {
  //const theme = useTheme();
  const [totalItems, setTotalItems] = React.useState(0);
  const [data, setData] = React.useState([]);

  const tasks = useSelector(state => state.tasks.allTasks);
  const patrols = useSelector(state => state.patrols.allPatrols);
  const constants = useSelector(state => state.constants.data);

  React.useEffect(() => {
    if(type == 'PATROL' && constants) {
      setTotalItems(patrols?.length);
      const statusMap = patrols.reduce((map, patrol) => {
    
        const code = patrol.status.code;
        if (!map[code]) map[code] = [];
        map[code].push(patrol);
        return map;
      }, {});
        
      setData([
        { label: 'FREE', value: statusMap['FREE']?.length },
        { label: 'OFFD', value: statusMap['OFFD']?.length },
        { label: 'PACK', value: statusMap['PACK']?.length },
        { label: 'UVOR', value: statusMap['UVOR']?.length },
        { label: 'HEAD', value: statusMap['HEAD']?.length },
        { label: 'ARVD', value: statusMap['ARVD']?.length },
        { label: 'BASE', value: statusMap['BASE']?.length },
      ]);
    }
  
    if(type == 'TASK' && constants) {
      setTotalItems(tasks?.length);
      const taskStatusMap = tasks.reduce((map, task) => {
        const status = constants.taskStatuses.find(s => s.id === task.statusId);
        const code = status?.code;
        if (!code) return map;
        if (!map[code]) map[code] = [];
        map[code].push(task);
        return map;
      }, {});
        
      setData([
        { label: 'PLAN', value: taskStatusMap['PLAN']?.length },
        { label: 'PACK', value: taskStatusMap['PACK']?.length },
        { label: 'HEAD', value: taskStatusMap['HEAD']?.length },
        { label: 'ARVD', value: taskStatusMap['ARVD']?.length },
        { label: 'COMP', value: taskStatusMap['COMP']?.length },
      ]);
    }
  }, [tasks, patrols, constants]);

  return (
    <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          {title}
        </Typography>
        <Stack
          direction="column"
          sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1 }}
        >
          <Stack sx={{ justifyContent: 'space-between' }}>
            <Stack
              direction="row"
              sx={{ justifyContent: 'space-between', alignItems: 'center' }}
            >
              <Typography variant="h4" component="p">
                {totalItems}
              </Typography>
              <ChartByStatus data={data} total={totalItems} />
            </Stack>
            
          </Stack>
          
        </Stack>
      </CardContent>
    </Card>
  );
}

export default SummaryCard;
